package com.eladfinish.bible.contest.screens.main.pastQuizzesSheet

import com.eladfinish.bible.contest.repository.remoteConfig.RemoteConfig
import com.eladfinish.bible.contest.repository.remoteConfig.RemoteConfigRepository
import com.eladfinish.bible.contest.screens.main.featureSheet.OneTimeSheetGate
import com.russhwolf.settings.Settings

/**
 * Who sees the one-time "what's new" sheet that introduces the "חידונים אמיתיים" button
 * ([com.eladfinish.bible.contest.screens.main.data.ButtonType.PAST_QUIZZES]): users who had the
 * app before it, once, on Android and iOS (web and desktop open the page in the browser).
 */
class PastQuizzesSheetGate(
    settings: Settings,
    remoteConfigRepository: RemoteConfigRepository,
    isSupportedPlatform: Boolean,
) : OneTimeSheetGate(
    settings = settings,
    remoteConfigRepository = remoteConfigRepository,
    isSupportedPlatform = isSupportedPlatform,
    existingUserKey = KEY_EXISTING_USER,
    shownKey = KEY_SHOWN,
    switchesThatMustBeOff = listOf(RemoteConfig.DISABLE_PAST_QUIZZES, RemoteConfig.DISABLE_PAST_QUIZZES_SHEET),
) {
    companion object {
        const val KEY_EXISTING_USER = "past_quizzes_sheet_existing_user"
        const val KEY_SHOWN = "past_quizzes_sheet_shown"
    }
}
